import React, { forwardRef } from 'react';
import { Thumb as Thumb$1 } from '../../../ui/popups/Popup/Thumb/index.js';

const Thumb = forwardRef(
  ({ value, ...props }, ref) => /* @__PURE__ */ React.createElement(Thumb$1, { ...props, ref })
);
Thumb.displayName = "Thumb";

export { Thumb };
//# sourceMappingURL=index.js.map
